import { Hero } from './components/hero';
import { BeforeYouBegin } from './components/before-you-begin';
import { ChooseCohort } from './components/choose-cohort';
import { useRoot } from './hooks/useRoot';
import { ErrorScreen } from '../../Error';
import { LoadingContainer } from '../shared/components/loading-container';
import { Suspense } from 'react';
import { ConsoleCJ } from '../../Error/Console';
import Container from '@/components/Container';
import PageHeader from '@/components/PageHeader';
import { AssessmentStatus, useChapterStore } from '../shared/store/useChapterStore';

const AssessmentComponent = () => {
  const { assessmentPage, errors, noCohortConfigured } = useRoot();
  const status = useChapterStore((state) => state.status);

  if (errors.length > 0) {
    ConsoleCJ.customError('AssessmentScreen - No mission slug', {
      ...errors,
      noCohortConfigured,
    });
    return <ErrorScreen message="No mission slug" />;
  }

  const title = (status === AssessmentStatus.PRE_ASSESSMENT ? 'Pre ' : 'Post ') + (assessmentPage?.title || '');

  return (
    <Container className="!mt-sh-60">
      <div className="col-span-12 lg:col-start-3 lg:col-end-11">
        <PageHeader title={title} type="none" />
        <div className="mt-5 pb-10">
          <Hero title={title} />
          {noCohortConfigured && <BeforeYouBegin />}
          {!noCohortConfigured && (
            <>
              <ChooseCohort />
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

export const AssessmentScreen = () => {
  return (
    <Suspense fallback={<LoadingContainer title="Loading assessment..." />}>
      <AssessmentComponent />
    </Suspense>
  );
};
